export default function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/size.js
// module id = 661
// module chunks = 4